import { cn } from "@tellescope/utils";
import type { TellescopeFormFieldBaseProps } from "../types";
import { NumberInput } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

export interface HeightFieldProps extends TellescopeFormFieldBaseProps<"Height"> {}

export const HeightField = ({ title, value, onChange, className, error, onBlur, touched }: HeightFieldProps) => {
  const { t } = useTranslation("forms");
  const showError = !!(error && touched);

  return (
    <div className="space-y-1">
      {!!title && <h4>{title}</h4>}
      <div className={cn("flex gap-2", className)}>
        <NumberInput
          value={value?.feet === 0 ? undefined : value?.feet}
          onChange={(feet) => onChange({ feet, inches: value?.inches ?? 0 })}
          onBlur={onBlur}
          placeholder={t("Feet")}
          className={cn(showError && "border-destructive")}
        />
        <NumberInput
          value={value?.inches === 0 ? undefined : value?.inches}
          onChange={(inches) => onChange({ feet: value?.feet ?? 0, inches })}
          onBlur={() => {
            if (value?.inches && value.inches > 11) {
              const newFeet = Math.floor(value.inches / 12) + (value?.feet ?? 0);
              const newInches = value.inches % 12;
              onChange({
                feet: newFeet,
                inches: newInches,
              });
            }
            onBlur?.();
          }}
          placeholder={t("Inches")}
          className={cn(showError && "border-destructive")}
        />
      </div>
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
